import React, { createContext, useContext, useState, useMemo, useCallback, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../hooks/auth';

const STORAGE_NEGOCIOS    = 'comercial_negocios';
const STORAGE_CONTATOS    = 'comercial_contatos';
const STORAGE_ATIVIDADES  = 'comercial_atividades_v2';
const STORAGE_PIPELINES   = 'comercial_pipelines_v2';
const STORAGE_PIPE_CARDS  = 'comercial_pipeline_cards_v2';
const STORAGE_METAS_PESSOAIS = 'comercial_metas_pessoais';
const STORAGE_METAS_GERAIS   = 'comercial_metas_gerais';

// ─── Pipeline Boards ─────────────────────────────────────────────────────────

export const PIPELINE_DEFAULT_ID = 'pipe-default';

const pipelinesMockInitial = [
    {
        id: PIPELINE_DEFAULT_ID,
        nome: 'Pipeline Principal',
        cor: '#02EA75',
        colunas: [
            { id: 'col-prosp', label: 'Prospecção',        cor: '#9F7AEA', ordem: 0 },
            { id: 'col-cont',  label: 'Contato Realizado',  cor: '#4299E1', ordem: 1 },
            { id: 'col-qual',  label: 'Qualificação',        cor: '#ECC94B', ordem: 2 },
            { id: 'col-prop',  label: 'Proposta Enviada',    cor: '#ED8936', ordem: 3 },
            { id: 'col-neg',   label: 'Em Negociação',       cor: '#FC8181', ordem: 4 },
            { id: 'col-ganho', label: 'Ganho',               cor: '#02EA75', ordem: 5 },
            { id: 'col-perd',  label: 'Perdido',             cor: '#718096', ordem: 6 },
        ],
    },
];

const pipelineCardsMockInitial = [
    { id: 'pc-1', pipelineId: 'pipe-default', colunaId: 'col-prop',  titulo: 'ERP + App Completo',         contato: 'Carlos Mendes',   empresa: 'FibraMax Telecom',    valor: 4500, probabilidade: 70, dataFechamento: '2026-06-15', responsavel: 'Lucas', canal: 'Indicação', prioridade: 'Alta',  observacoes: '',                      criadoEm: '2026-05-01T10:00:00' },
    { id: 'pc-2', pipelineId: 'pipe-default', colunaId: 'col-neg',   titulo: 'App Android + iOS',          contato: 'Ana Lima',        empresa: 'NetVale Internet',    valor: 3200, probabilidade: 85, dataFechamento: '2026-05-25', responsavel: 'Lucas', canal: 'Site',      prioridade: 'Alta',  observacoes: '',                      criadoEm: '2026-04-20T14:00:00' },
    { id: 'pc-3', pipelineId: 'pipe-default', colunaId: 'col-qual',  titulo: 'Painel + Site Institucional', contato: 'Roberto Alves',   empresa: 'ViaNet Fibra',        valor: 2800, probabilidade: 50, dataFechamento: '2026-06-30', responsavel: 'Lucas', canal: 'LinkedIn',  prioridade: 'Média', observacoes: '',                      criadoEm: '2026-05-05T09:00:00' },
    { id: 'pc-4', pipelineId: 'pipe-default', colunaId: 'col-prosp', titulo: 'Sistema Completo Nogle',     contato: 'Fernanda Costa',  empresa: 'SpeedNet Telecom',    valor: 7800, probabilidade: 30, dataFechamento: '2026-07-31', responsavel: 'Lucas', canal: 'Indicação', prioridade: 'Baixa', observacoes: '',                      criadoEm: '2026-05-08T11:00:00' },
    { id: 'pc-5', pipelineId: 'pipe-default', colunaId: 'col-ganho', titulo: 'App Fidelidade + Recarga',   contato: 'Marcos Souza',    empresa: 'LinkFibra',           valor: 1900, probabilidade: 100,dataFechamento: '2026-05-10', responsavel: 'Lucas', canal: 'Evento',    prioridade: 'Média', observacoes: 'Contrato assinado.',    criadoEm: '2026-04-15T08:00:00' },
    { id: 'pc-6', pipelineId: 'pipe-default', colunaId: 'col-cont',  titulo: 'ERP Básico + Suporte',       contato: 'Patricia Ramos',  empresa: 'MaxFibra ISP',        valor: 2100, probabilidade: 40, dataFechamento: '2026-06-20', responsavel: 'Lucas', canal: 'WhatsApp',  prioridade: 'Baixa', observacoes: '',                      criadoEm: '2026-05-07T15:00:00' },
    { id: 'pc-7', pipelineId: 'pipe-default', colunaId: 'col-prop',  titulo: 'Plataforma Venda Direta',    contato: 'Diego Martins',   empresa: 'NovaTelecom',         valor: 3600, probabilidade: 60, dataFechamento: '2026-06-10', responsavel: 'Lucas', canal: 'E-mail',    prioridade: 'Média', observacoes: '',                      criadoEm: '2026-05-03T13:00:00' },
    { id: 'pc-8', pipelineId: 'pipe-default', colunaId: 'col-perd',  titulo: 'Split de Pagamentos',        contato: 'Juliana Ferreira',empresa: 'ConexFibra',          valor: 1200, probabilidade: 0,  dataFechamento: '2026-04-30', responsavel: 'Lucas', canal: 'Telefone',  prioridade: 'Baixa', observacoes: 'Optou por outra solução.',criadoEm: '2026-04-10T10:00:00' },
];

export const ETAPAS_PIPELINE = [
    { id: 'prospeccao',   label: 'Prospecção',        cor: '#9F7AEA', ordem: 0 },
    { id: 'contato',      label: 'Contato Realizado',  cor: '#4299E1', ordem: 1 },
    { id: 'qualificacao', label: 'Qualificação',        cor: '#ECC94B', ordem: 2 },
    { id: 'proposta',     label: 'Proposta Enviada',    cor: '#ED8936', ordem: 3 },
    { id: 'negociacao',   label: 'Em Negociação',       cor: '#FC8181', ordem: 4 },
    { id: 'ganho',        label: 'Ganho',               cor: '#02EA75', ordem: 5 },
    { id: 'perdido',      label: 'Perdido',             cor: '#718096', ordem: 6 },
];

export const CANAIS = ['Indicação', 'Site', 'LinkedIn', 'WhatsApp', 'Telefone', 'Evento', 'E-mail', 'Outro'];

export const TIPOS_ATIVIDADE = ['Ligação', 'E-mail', 'Reunião', 'WhatsApp', 'Visita', 'Tarefa'];
export const TIPOS_ATIVIDADE_V2 = ['Evento', 'Reunião', 'Ligação', 'E-mail', 'WhatsApp', 'Visita', 'Tarefa', 'Prazo', 'Entrega'];

const negociosMockInitial = [
    {
        id: 'neg-1', titulo: 'ERP + App Completo', contato: 'Carlos Mendes',
        empresa: 'FibraMax Telecom', valor: 4500, etapa: 'proposta',
        probabilidade: 70, dataFechamento: '2026-06-15',
        responsavel: 'Lucas', canal: 'Indicação', observacoes: '',
        criadoEm: '2026-05-01T10:00:00',
    },
    {
        id: 'neg-2', titulo: 'App Android + iOS', contato: 'Ana Lima',
        empresa: 'NetVale Internet', valor: 3200, etapa: 'negociacao',
        probabilidade: 85, dataFechamento: '2026-05-25',
        responsavel: 'Lucas', canal: 'Site', observacoes: '',
        criadoEm: '2026-04-20T14:00:00',
    },
    {
        id: 'neg-3', titulo: 'Painel + Site Institucional', contato: 'Roberto Alves',
        empresa: 'ViaNet Fibra', valor: 2800, etapa: 'qualificacao',
        probabilidade: 50, dataFechamento: '2026-06-30',
        responsavel: 'Lucas', canal: 'LinkedIn', observacoes: '',
        criadoEm: '2026-05-05T09:00:00',
    },
    {
        id: 'neg-4', titulo: 'Sistema Completo Nogle', contato: 'Fernanda Costa',
        empresa: 'SpeedNet Telecom', valor: 7800, etapa: 'prospeccao',
        probabilidade: 30, dataFechamento: '2026-07-31',
        responsavel: 'Lucas', canal: 'Indicação', observacoes: '',
        criadoEm: '2026-05-08T11:00:00',
    },
    {
        id: 'neg-5', titulo: 'App Fidelidade + Recarga', contato: 'Marcos Souza',
        empresa: 'LinkFibra', valor: 1900, etapa: 'ganho',
        probabilidade: 100, dataFechamento: '2026-05-10',
        responsavel: 'Lucas', canal: 'Evento', observacoes: 'Contrato assinado.',
        criadoEm: '2026-04-15T08:00:00',
    },
    {
        id: 'neg-6', titulo: 'ERP Básico + Suporte', contato: 'Patricia Ramos',
        empresa: 'MaxFibra ISP', valor: 2100, etapa: 'contato',
        probabilidade: 40, dataFechamento: '2026-06-20',
        responsavel: 'Lucas', canal: 'WhatsApp', observacoes: '',
        criadoEm: '2026-05-07T15:00:00',
    },
    {
        id: 'neg-7', titulo: 'Plataforma Venda Direta', contato: 'Diego Martins',
        empresa: 'NovaTelecom', valor: 3600, etapa: 'proposta',
        probabilidade: 60, dataFechamento: '2026-06-10',
        responsavel: 'Lucas', canal: 'E-mail', observacoes: '',
        criadoEm: '2026-05-03T13:00:00',
    },
    {
        id: 'neg-8', titulo: 'Split de Pagamentos', contato: 'Juliana Ferreira',
        empresa: 'ConexFibra', valor: 1200, etapa: 'perdido',
        probabilidade: 0, dataFechamento: '2026-04-30',
        responsavel: 'Lucas', canal: 'Telefone', observacoes: 'Cliente optou por outra solução.',
        criadoEm: '2026-04-10T10:00:00',
    },
];

const contatosMockInitial = [
    { id: 'cont-1', nome: 'Carlos Mendes', empresa: 'FibraMax Telecom', telefone: '(11) 98765-4321', email: 'carlos@fibramax.com.br', cargo: 'Diretor Comercial', canal: 'Indicação', observacoes: '', criadoEm: '2026-05-01T10:00:00', criadoPor: 'Lucas' },
    { id: 'cont-2', nome: 'Ana Lima', empresa: 'NetVale Internet', telefone: '(31) 97654-3210', email: 'ana@netvale.com.br', cargo: 'CEO', canal: 'Site', observacoes: '', criadoEm: '2026-04-20T14:00:00', criadoPor: 'Lucas' },
    { id: 'cont-3', nome: 'Roberto Alves', empresa: 'ViaNet Fibra', telefone: '(21) 96543-2109', email: 'roberto@vianet.com.br', cargo: 'Gerente de TI', canal: 'LinkedIn', observacoes: '', criadoEm: '2026-05-05T09:00:00', criadoPor: 'Alex' },
    { id: 'cont-4', nome: 'Fernanda Costa', empresa: 'SpeedNet Telecom', telefone: '(41) 95432-1098', email: 'fernanda@speednet.com.br', cargo: 'Sócia-Proprietária', canal: 'Indicação', observacoes: '', criadoEm: '2026-05-08T11:00:00', criadoPor: 'Victorio' },
    { id: 'cont-5', nome: 'Marcos Souza', empresa: 'LinkFibra', telefone: '(85) 94321-0987', email: 'marcos@linkfibra.com.br', cargo: 'Diretor', canal: 'Evento', observacoes: '', criadoEm: '2026-04-15T08:00:00', criadoPor: 'Lucas' },
];

// Atividades v2 — formato Calendário: nome, dataInicio, dataFim, tipo, responsavel, observacao, ligarPipeline
const atividadesMockInitial = [
    { id: 'atv-1', nome: 'Apresentar proposta técnica para Carlos', dataInicio: '2026-06-05', dataFim: '2026-06-05', tipo: 'Reunião', responsavel: 'Lucas', observacao: 'Levar apresentação do ERP completo', ligarPipeline: true, status: 'pendente', criadoEm: '2026-05-10T09:00:00', criadoPor: 'Lucas' },
    { id: 'atv-2', nome: 'Follow-up sobre contrato App', dataInicio: '2026-06-03', dataFim: '2026-06-03', tipo: 'Ligação', responsavel: 'Alex', observacao: '', ligarPipeline: false, status: 'concluido', criadoEm: '2026-05-08T10:00:00', criadoPor: 'Alex' },
    { id: 'atv-3', nome: 'Enviar catálogo de soluções Nogle', dataInicio: '2026-06-07', dataFim: '2026-06-07', tipo: 'WhatsApp', responsavel: 'Victorio', observacao: 'Catálogo atualizado com preços de junho', ligarPipeline: true, status: 'pendente', criadoEm: '2026-05-09T11:00:00', criadoPor: 'Victorio' },
    { id: 'atv-4', nome: 'Enviar proposta revisada com desconto', dataInicio: '2026-06-10', dataFim: '2026-06-10', tipo: 'E-mail', responsavel: 'Lucas', observacao: 'Desconto de 15% aprovado pela diretoria', ligarPipeline: true, status: 'pendente', criadoEm: '2026-05-10T14:00:00', criadoPor: 'Lucas' },
    { id: 'atv-5', nome: 'Demo da plataforma de vendas', dataInicio: '2026-06-15', dataFim: '2026-06-16', tipo: 'Reunião', responsavel: 'Lucas', observacao: 'Demo online via Google Meet', ligarPipeline: false, status: 'pendente', criadoEm: '2026-05-10T16:00:00', criadoPor: 'Alex' },
    { id: 'atv-6', nome: 'Onboarding Marca Nova', dataInicio: '2026-06-20', dataFim: '2026-06-22', tipo: 'Evento', responsavel: 'Victorio', observacao: 'Configurar ERP, App e Painel da nova marca', ligarPipeline: true, status: 'pendente', criadoEm: '2026-05-15T08:00:00', criadoPor: 'Lucas' },
];

// Metas mock
const metasPessoaisMockInitial = [
    { id: 'meta-p1', titulo: 'Fechar 5 contratos no mês', descricao: 'Bater a meta de vendas individual de junho', prazo: '2026-06-30', progresso: 40, criadoEm: '2026-06-01T09:00:00', criadoPor: 'Lucas' },
    { id: 'meta-p2', titulo: 'Aprender módulo Notify', descricao: 'Dominar configuração e demonstração do Notify para clientes', prazo: '2026-06-15', progresso: 70, criadoEm: '2026-06-01T09:00:00', criadoPor: 'Lucas' },
];

const metasGeraisMockInitial = [
    { id: 'meta-g1', titulo: 'Faturamento R$ 50.000 em junho', descricao: 'Meta geral do time comercial para o mês de junho', prazo: '2026-06-30', progresso: 25, criadoEm: '2026-06-01T09:00:00', criadoPor: 'Admin' },
    { id: 'meta-g2', titulo: '20 marcas em produção ativa', descricao: 'Manter pipeline de produção sempre com pelo menos 20 marcas', prazo: '2026-07-31', progresso: 60, criadoEm: '2026-06-01T09:00:00', criadoPor: 'Admin' },
];

const parseCommentToCompromisso = (c) => {
    let parsed = {};
    try {
        if (c.comment && (c.comment.startsWith('{') || c.comment.startsWith('['))) {
            parsed = JSON.parse(c.comment);
        }
    } catch (e) {
        parsed = {
            titulo: c.comment || '',
            local: '',
            descricao: '',
            tipo: c.category_id === 4 ?'Reunião' : (c.category_id === 3 ?'Prazo' : 'Evento'),
            concluido: false
        };
    }

    const startStr = c.start_date ?(typeof c.start_date === 'string' ?c.start_date.split('T')[0] : new Date(c.start_date).toISOString().split('T')[0]) : '';
    const endStr = c.end_date ?(typeof c.end_date === 'string' ?c.end_date.split('T')[0] : new Date(c.end_date).toISOString().split('T')[0]) : '';

    return {
        id: c.id,
        employee_id: c.employee_id,
        responsavel: c.responsavel || '',
        data: startStr,
        dataFim: endStr,
        titulo: parsed.titulo || c.comment || '',
        tipo: parsed.tipo || 'Evento',
        hora: parsed.hora || parsed.horaInicio || '09:00',
        horaInicio: parsed.horaInicio || parsed.hora || '09:00',
        horaFim: parsed.horaFim || '10:00',
        duracao: parsed.duracao || 60,
        local: parsed.local || '',
        descricao: parsed.descricao || '',
        concluido: !!parsed.concluido,
        cardId: parsed.cardId || null
    };
};

const ComercialContext = createContext(null);

const mapColumnLabelToEtapa = (label) => {
    if (!label) return 'prospeccao';
    const lower = label.toLowerCase();
    if (lower.includes('prospec')) return 'prospeccao';
    if (lower.includes('contato')) return 'contato';
    if (lower.includes('qualific')) return 'qualificacao';
    if (lower.includes('proposta')) return 'proposta';
    if (lower.includes('negocia')) return 'negociacao';
    if (lower.includes('ganho')) return 'ganho';
    if (lower.includes('perdido')) return 'perdido';
    return 'prospeccao'; // fallback
};

export const ComercialProvider = ({ children }) => {
    const { user } = useAuth();

    const [contatos, setContatos] = useState([]);
    const [atividades, setAtividades] = useState([]);
    const [loadingContatos, setLoadingContatos] = useState(true);
    const [loadingAtividades, setLoadingAtividades] = useState(true);

    const [pipelines, setPipelines] = useState([]);
    const [pipelineCards, setPipelineCards] = useState([]);
    const [loadingPipelines, setLoadingPipelines] = useState(true);
    const [loadingPipelineCards, setLoadingPipelineCards] = useState(true);
    const [resultadosNegocio, setResultadosNegocio] = useState([]);
    // Canais de origem vindos do banco (CONTROLADORES_COMERCIAL_NOGLE, type "canais").
    // Exposto como canaisDropdown para não confundir com a lista fixa CANAIS (fallback).
    const [canaisDropdown, setCanaisDropdown] = useState([]);
    // Tipos e status de atividade (CONTROLADORES_COMERCIAL_NOGLE, types "tipos_atividade"
    // e "status_atividade"). Carregados no login como os demais dropdowns do contexto,
    // para o formulário Criar Evento não depender de um único fetch da página Atividades.
    const [tiposAtividade, setTiposAtividade] = useState([]);
    const [statusAtividade, setStatusAtividade] = useState([]);

    const fetchContatos = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/contatos');
            setContatos(data);
        } catch (err) {
            console.error("Erro ao carregar contatos:", err);
        } finally {
            setLoadingContatos(false);
        }
    }, []);

    const fetchAtividades = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/atividades');
            setAtividades(data.map(a => ({
                id: a.id,
                nome: a.nome,
                dataInicio: a.start ?a.start.split('T')[0] : '',
                horaInicio: a.start && a.start.includes('T') ?a.start.split('T')[1].slice(0, 5) : '00:00',
                dataFim: a.end ?a.end.split('T')[0] : '',
                horaFim: a.end && a.end.includes('T') ?a.end.split('T')[1].slice(0, 5) : '00:00',
                tipo: a.tipo,
                tipo_id: a.tipo_id,
                tipo_cor: a.tipo_cor || null,
                assignee_id: a.assignee_id,
                responsavel: a.responsavel,
                status: a.status,
                status_id: a.status_id,
                // Papel do status (0 neutro/pendente | 1 positivo/concluída | 2 negativo/cancelada):
                // as telas classificam por aqui — o NOME do status é 100% cosmético.
                status_role: a.status_role ?? null,
                status_cor: a.status_cor || null,
                ligarPipeline: !!a.ligarPipeline,
                cardId: a.card_id != null ?String(a.card_id) : null,
                company_id: a.company_id,
                empresa: a.empresa,
                observacao: a.observacao || '',
                completed: a.completed === 1 || a.completed === true,
                canceled: a.canceled === 1 || a.canceled === true
            })));
        } catch (err) {
            console.error("Erro ao carregar atividades:", err);
        } finally {
            setLoadingAtividades(false);
        }
    }, []);

    const [compromissosComercial, setCompromissosComercial] = useState([]);
    const [loadingCompromissos, setLoadingCompromissos] = useState(true);

    const fetchCompromissosComercial = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/compromissos');
            setCompromissosComercial(data);
        } catch (err) {
            console.error("Erro ao carregar compromissos comerciais:", err);
        } finally {
            setLoadingCompromissos(false);
        }
    }, []);

    const fetchPipelines = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/funis');
            setPipelines(data);
        } catch (err) {
            console.error("Erro ao carregar pipelines (funis):", err);
        } finally {
            setLoadingPipelines(false);
        }
    }, []);

    const fetchResultadosNegocio = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/dropdowns/resultados_negocio');
            setResultadosNegocio(data || []);
        } catch (err) {
            console.error("Erro ao carregar resultados de negocio:", err);
        }
    }, []);

    const fetchCanais = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/dropdowns/canais');
            setCanaisDropdown(data || []);
        } catch (err) {
            console.error("Erro ao carregar canais de origem:", err);
        }
    }, []);

    const fetchTiposAtividade = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/dropdowns/tipos_atividade');
            setTiposAtividade(data || []);
        } catch (err) {
            console.error("Erro ao carregar tipos de atividade:", err);
        }
    }, []);

    const fetchStatusAtividade = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/dropdowns/status_atividade');
            setStatusAtividade(data || []);
        } catch (err) {
            console.error("Erro ao carregar status de atividade:", err);
        }
    }, []);

    const fetchPipelineCards = useCallback(async () => {
        try {
            const { data } = await api.get('/comercial/pipeline-cards');
            setPipelineCards(data.map(c => {
                // A API entrega `contato` (coluna própria contact_) e `observacoes` em
                // texto puro. O parse abaixo é só fallback para o legado, quando o JSON
                // {"contato","observacoes"} ainda vinha embutido em observations_.
                let contato = c.contato || '';
                let obsText = '';
                try {
                    if (c.observacoes && (c.observacoes.startsWith('{') || c.observacoes.startsWith('['))) {
                        const parsed = JSON.parse(c.observacoes);
                        contato = contato || parsed.contato || '';
                        obsText = parsed.observacoes || '';
                    } else {
                        obsText = c.observacoes || '';
                    }
                } catch(e) {
                    obsText = c.observacoes || '';
                }
                // Empresa externa: sem id_company do sistema, mas com nome digitado (name_company)
                const empresaExterna = !c.company_id && !!(c.name_company || c.empresa);
                return {
                    id: c.id,
                    pipelineId: c.pipelineId,
                    colunaId: c.colunaId,
                    titulo: c.titulo,
                    company_id: c.company_id,
                    name_company: c.name_company || null,
                    empresa: c.empresa || c.name_company || '',
                    // origem do cliente (para badges no card/modal)
                    marcaId: c.company_id || null,
                    clienteNovo: empresaExterna,
                    empresaExterna,
                    valor: c.valor,
                    probabilidade: c.probabilidade,
                    dataInicio: c.dataInicio ?c.dataInicio.split('T')[0] : null,
                    dataFechamento: c.dataFechamento ?c.dataFechamento.split('T')[0] : null,
                    color_card_date: c.color_card_date || 1,
                    responsavel: c.responsavel,
                    assignee_id: c.assignee_id,
                    canal: c.canal,
                    prioridade: c.prioridade,
                    contato,
                    observacoes: obsText,
                    meetLink: c.meetLink || '',
                    completed: c.completed === 1 || c.completed === true,
                    canceled: c.canceled === 1 || c.canceled === true,
                    result_id: c.result_id,
                    resultado: c.resultado,
                    // Papel do resultado (0 neutro | 1 positivo/ganho | 2 negativo/perdido):
                    // classificação ganho/perdido usa isto — nunca o nome do resultado.
                    result_role: c.result_role ?? null
                };
            }));
        } catch (err) {
            console.error("Erro ao carregar cartões do pipeline:", err);
        } finally {
            setLoadingPipelineCards(false);
        }
    }, []);

    useEffect(() => {
        if (user) {
            fetchContatos();
            fetchAtividades();
            fetchCompromissosComercial();
            fetchPipelines();
            fetchPipelineCards();
            fetchResultadosNegocio();
            fetchCanais();
            fetchTiposAtividade();
            fetchStatusAtividade();
        } else {
            setContatos([]);
            setAtividades([]);
            setCompromissosComercial([]);
            setPipelines([]);
            setPipelineCards([]);
            setResultadosNegocio([]);
            setCanaisDropdown([]);
            setTiposAtividade([]);
            setStatusAtividade([]);
        }
    }, [user, fetchContatos, fetchAtividades, fetchCompromissosComercial, fetchPipelines, fetchPipelineCards, fetchResultadosNegocio, fetchCanais, fetchTiposAtividade, fetchStatusAtividade]);

    // --- Pipeline Boards CRUD ---
    const addPipeline = useCallback(async (nome, cor = '#4299E1', assignee_id = null) => {
        try {
            const { data } = await api.post('/comercial/funis', { nome, cor, assignee_id });
            await fetchPipelines();
            return data;
        } catch (err) {
            console.error("Erro ao adicionar pipeline:", err);
            throw err;
        }
    }, [fetchPipelines]);

    const updatePipeline = useCallback(async (id, patch) => {
        try {
            await api.put(`/comercial/funis/${id}`, patch);
            await fetchPipelines();
        } catch (err) {
            console.error("Erro ao atualizar pipeline:", err);
            throw err;
        }
    }, [fetchPipelines]);

    const deletePipeline = useCallback(async (id) => {
        try {
            await api.delete(`/comercial/funis/${id}`);
            await fetchPipelines();
            await fetchPipelineCards();
        } catch (err) {
            console.error("Erro ao deletar pipeline:", err);
            throw err;
        }
    }, [fetchPipelines, fetchPipelineCards]);

    const addColuna = useCallback(async (pipelineId, { label, cor, tipo }) => {
        try {
            const pipeline = pipelines.find(p => p.id === pipelineId);
            const ordem = pipeline ?pipeline.colunas.length : 0;
            const payload = {
                funilId: pipelineId,
                label,
                cor: cor || '#4299E1',
                tipo: tipo || 'aberto',
                ordem
            };
            const { data } = await api.post('/comercial/colunas', payload);
            await fetchPipelines();
            return data;
        } catch (err) {
            console.error("Erro ao adicionar coluna:", err);
            throw err;
        }
    }, [pipelines, fetchPipelines]);

    const updateColuna = useCallback(async (pipelineId, colunaId, patch) => {
        try {
            await api.put(`/comercial/colunas/${colunaId}`, patch);
            await fetchPipelines();
        } catch (err) {
            console.error("Erro ao atualizar coluna:", err);
            throw err;
        }
    }, [fetchPipelines]);

    const deleteColuna = useCallback(async (pipelineId, colunaId) => {
        try {
            await api.delete(`/comercial/colunas/${colunaId}`);
            await fetchPipelines();
            await fetchPipelineCards();
        } catch (err) {
            console.error("Erro ao deletar coluna:", err);
            throw err;
        }
    }, [fetchPipelines, fetchPipelineCards]);

    const addPipelineCard = useCallback(async (card) => {
        try {
            const payload = {
                company_id: card.company_id,
                name_company: card.company_id ?null : (card.name_company || card.empresa || null),
                titulo: card.titulo,
                valor: card.valor,
                probabilidade: card.probabilidade,
                colunaId: card.colunaId,
                prioridade: card.prioridade,
                canal: card.canal,
                dataInicio: card.dataInicio,
                dataFechamento: card.dataFechamento,
                assignee_id: card.assignee_id,
                observacoes: card.observacoes,
                contato: card.contato,
                meetLink: card.meetLink,
                completed: card.completed ?1 : 0,
                result_id: card.result_id
            };
            const { data } = await api.post('/comercial/pipeline-cards', payload);
            await fetchPipelineCards();
            return data;
        } catch (err) {
            console.error("Erro ao adicionar pipeline card:", err);
            throw err;
        }
    }, [fetchPipelineCards]);

    const updatePipelineCard = useCallback(async (id, patch) => {
        try {
            const payload = {};
            if ('company_id' in patch) payload.company_id = patch.company_id;
            if ('name_company' in patch || 'empresa' in patch) {
                payload.name_company = patch.company_id ? null : (patch.name_company || patch.empresa || null);
            }
            if ('titulo' in patch) payload.titulo = patch.titulo;
            if ('valor' in patch) payload.valor = patch.valor;
            if ('probabilidade' in patch) payload.probabilidade = patch.probabilidade;
            if ('colunaId' in patch) payload.colunaId = patch.colunaId;
            if ('prioridade' in patch) payload.prioridade = patch.prioridade;
            if ('canal' in patch) payload.canal = patch.canal;
            if ('dataInicio' in patch) payload.dataInicio = patch.dataInicio;
            if ('dataFechamento' in patch) payload.dataFechamento = patch.dataFechamento;
            if ('assignee_id' in patch) payload.assignee_id = patch.assignee_id;
            if ('observacoes' in patch) payload.observacoes = patch.observacoes;
            if ('contato' in patch) payload.contato = patch.contato;
            if ('meetLink' in patch) payload.meetLink = patch.meetLink;
            if ('completed' in patch) payload.completed = patch.completed ?1 : 0;
            if ('canceled' in patch) payload.canceled = patch.canceled ?1 : 0;
            if ('result_id' in patch) payload.result_id = patch.result_id;

            await api.put(`/comercial/pipeline-cards/${id}`, payload);
            await fetchPipelineCards();
        } catch (err) {
            console.error("Erro ao atualizar pipeline card:", err);
            throw err;
        }
    }, [fetchPipelineCards]);

    const deletePipelineCard = useCallback(async (id) => {
        try {
            await api.delete(`/comercial/pipeline-cards/${id}`);
            await fetchPipelineCards();
        } catch (err) {
            console.error("Erro ao deletar pipeline card:", err);
            throw err;
        }
    }, [fetchPipelineCards]);

    const moverCard = useCallback((cardId, novaColunaId) => {
        // Keeps the existing completed flag. Cards are only marked completed when the user explicitly clicks "Concluir" on the details.
        updatePipelineCard(cardId, { colunaId: novaColunaId });
    }, [updatePipelineCard]);

    // Reabre um item concluído (completed → 0): negócio volta pro Pipeline, atividade pra Atividades.
    const reabrirItem = useCallback(async (tipo, id) => {
        await api.put(`/comercial/metas/reabrir/${tipo}/${id}`);
        if (tipo === 'negocio') await fetchPipelineCards();
        else if (tipo === 'atividade') await fetchAtividades();
    }, [fetchPipelineCards, fetchAtividades]);

    const addCompromisso = useCallback(async (cardId, comp) => {
        try {
            const typeToCategory = {
                'Reunião': 4,
                'Ligação': 2,
                'Follow-up': 2,
                'Prazo': 3,
                'Entrega': 3,
                'Outro': 2
            };
            const categoryId = typeToCategory[comp.tipo] || 2;

            const serializedComment = JSON.stringify({
                cardId,
                titulo: comp.titulo,
                tipo: comp.tipo,
                hora: comp.horaInicio || comp.hora,   // compat
                horaInicio: comp.horaInicio || comp.hora,
                horaFim: comp.horaFim || '',
                duracao: comp.duracao,
                local: comp.local,
                descricao: comp.descricao,
                concluido: !!comp.concluido
            });

            const payload = {
                employeeId: comp.employee_id || comp.assignee_id || null,
                startISO: comp.data,
                endISO: comp.dataFim || comp.data,
                comment: serializedComment,
                categoryId
            };

            const { data } = await api.post('/comercial/compromissos', payload);
            await fetchCompromissosComercial();
            const newCompRecord = {
                id: data.id,
                employee_id: data.employeeId,
                start_date: data.startISO,
                end_date: data.endISO,
                comment: data.comment,
                category_id: data.categoryId
            };
            return parseCommentToCompromisso(newCompRecord);
        } catch (err) {
            console.error("Erro ao adicionar compromisso:", err);
            throw err;
        }
    }, [fetchCompromissosComercial]);

    const updateCompromisso = useCallback(async (cardId, compId, patch) => {
        try {
            const existing = compromissosComercial.find(c => c.id === compId);
            if (!existing) return;

            const parsed = parseCommentToCompromisso(existing);
            const merged = { ...parsed, ...patch };

            const typeToCategory = {
                'Reunião': 4,
                'Ligação': 2,
                'Follow-up': 2,
                'Prazo': 3,
                'Entrega': 3,
                'Outro': 2
            };
            const categoryId = typeToCategory[merged.tipo] || 2;

            const serializedComment = JSON.stringify({
                cardId: merged.cardId || cardId,
                titulo: merged.titulo,
                tipo: merged.tipo,
                hora: merged.horaInicio || merged.hora,   // compat
                horaInicio: merged.horaInicio || merged.hora,
                horaFim: merged.horaFim || '',
                duracao: merged.duracao,
                local: merged.local,
                descricao: merged.descricao,
                concluido: !!merged.concluido
            });

            const payload = {
                employeeId: merged.employee_id || null,
                startISO: merged.data,
                endISO: merged.dataFim || merged.data,
                comment: serializedComment,
                categoryId
            };

            await api.put(`/comercial/compromissos/${compId}`, payload);
            await fetchCompromissosComercial();
        } catch (err) {
            console.error("Erro ao atualizar compromisso:", err);
            throw err;
        }
    }, [compromissosComercial, fetchCompromissosComercial]);

    const deleteCompromisso = useCallback(async (compId) => {
        try {
            await api.delete(`/comercial/compromissos/${compId}`);
            await fetchCompromissosComercial();
        } catch (err) {
            console.error("Erro ao deletar compromisso:", err);
            throw err;
        }
    }, [fetchCompromissosComercial]);

    const pipelineCardsWithCompromissos = useMemo(() => {
        const groups = {};
        compromissosComercial.forEach(c => {
            const parsed = parseCommentToCompromisso(c);
            if (parsed.cardId) {
                if (!groups[parsed.cardId]) {
                    groups[parsed.cardId] = [];
                }
                groups[parsed.cardId].push(parsed);
            }
        });

        return pipelineCards.map(card => {
            return {
                ...card,
                compromissos: groups[card.id] || []
            };
        });
    }, [pipelineCards, compromissosComercial]);

    // Lista plana de TODOS os compromissos (para o Calendário), já parseados e
    // enriquecidos com o título/empresa do negócio vinculado (cardId).
    const compromissos = useMemo(() => {
        const cardsById = {};
        pipelineCards.forEach(c => { cardsById[c.id] = c; });
        return (compromissosComercial || []).map(c => {
            const parsed = parseCommentToCompromisso(c);
            const card = parsed.cardId ?cardsById[parsed.cardId] : null;
            return {
                ...parsed,
                cardTitulo: card?.titulo || null,
                cardEmpresa: card?.empresa || null,
            };
        });
    }, [compromissosComercial, pipelineCards]);

    // --- Derived negocios state ---
    // Cancelados ficam fora da derivação: somem dos KPIs/funil do Dashboard
    // (na tela Negócios eles aparecem via pipelineCards + filtro "Cancelados").
    const negocios = useMemo(() => {
        const columnMap = {};
        pipelines.forEach(p => {
            if (p.colunas) {
                p.colunas.forEach(col => {
                    columnMap[col.id] = col;
                });
            }
        });

        return pipelineCards.filter(c => !c.canceled).map(c => {
            const col = columnMap[c.colunaId];
            // Etapa ganho/perdido vem do TIPO da coluna (renomear coluna não muda a
            // classificação); o mapeamento por nome fica só como fallback legado.
            const etapa = (col?.tipo === 'ganho' || col?.tipo === 'perdido')
                ? col.tipo
                : mapColumnLabelToEtapa(col?.label || '');
            return {
                id: c.id,
                titulo: c.titulo || '',
                contato: c.contato || '',
                empresa: c.empresa || '',
                valor: c.valor || 0,
                etapa,
                // Concluído (qualquer resultado, ex.: "Em espera") não conta como
                // negócio em aberto nos KPIs — mesmo quando a coluna é de etapa aberta.
                completed: !!c.completed,
                probabilidade: c.probabilidade || 0,
                dataFechamento: c.dataFechamento,
                responsavel: c.responsavel || '',
                canal: c.canal || '',
                observacoes: c.observacoes || '',
                criadoEm: c.criadoEm || new Date().toISOString()
            };
        });
    }, [pipelines, pipelineCards]);

    // Deprecated negocios legacy operations
    const addNegocio = useCallback((neg) => {
        console.warn("addNegocio is deprecated, use addPipelineCard instead.");
        return neg;
    }, []);
    const updateNegocio = useCallback((id, patch) => {
        console.warn("updateNegocio is deprecated, use updatePipelineCard instead.");
    }, []);
    const deleteNegocio = useCallback((id) => {
        console.warn("deleteNegocio is deprecated, use deletePipelineCard instead.");
    }, []);
    const moverEtapa = useCallback((id, direcao) => {
        console.warn("moverEtapa is deprecated.");
    }, []);

    // --- Atividades CRUD (v2 — formato calendário) ---
    const addAtividade = useCallback(async (atividade) => {
        try {
            const startISO = `${atividade.dataInicio}T${atividade.horaInicio || '00:00'}:00`;
            const endISO = `${atividade.dataFim || atividade.dataInicio}T${atividade.horaFim || atividade.horaInicio || '00:00'}:00`;
            const payload = {
                nome: atividade.nome,
                start: startISO,
                end: endISO,
                tipo: atividade.tipo_id || atividade.tipo,
                assignee_id: atividade.assignee_id,
                status: atividade.status_id || atividade.status,
                ligarPipeline: !!atividade.ligarPipeline || atividade.cardId != null,
                card_id: atividade.cardId != null ?Number(atividade.cardId) : null,
                company_id: atividade.company_id,
                observacao: atividade.observacao || ''
            };
            const { data } = await api.post('/comercial/atividades', payload);
            fetchAtividades();
            return data;
        } catch (err) {
            console.error("Erro ao adicionar atividade:", err);
            throw err;
        }
    }, [fetchAtividades]);

    const updateAtividade = useCallback(async (id, patch) => {
        try {
            const startISO = `${patch.dataInicio}T${patch.horaInicio || '00:00'}:00`;
            const endISO = `${patch.dataFim || patch.dataInicio}T${patch.horaFim || patch.horaInicio || '00:00'}:00`;
            const payload = {
                nome: patch.nome,
                start: startISO,
                end: endISO,
                tipo: patch.tipo_id || patch.tipo,
                assignee_id: patch.assignee_id,
                status: patch.status_id || patch.status,
                ligarPipeline: !!patch.ligarPipeline || patch.cardId != null,
                card_id: patch.cardId != null ?Number(patch.cardId) : null,
                company_id: patch.company_id,
                observacao: patch.observacao || ''
            };
            await api.put(`/comercial/atividades/${id}`, payload);
            fetchAtividades();
        } catch (err) {
            console.error("Erro ao atualizar atividade:", err);
            throw err;
        }
    }, [fetchAtividades]);

    const deleteAtividade = useCallback(async (id) => {
        try {
            await api.delete(`/comercial/atividades/${id}`);
            fetchAtividades();
        } catch (err) {
            console.error("Erro ao deletar atividade:", err);
            throw err;
        }
    }, [fetchAtividades]);

    // --- Contatos CRUD ---
    const addContato = useCallback(async (contato) => {
        try {
            const payload = {
                nome: contato.nome,
                cargo: contato.cargo_id || contato.cargo,
                company_id: contato.company_id,
                telefone: contato.telefone,
                email: contato.email,
                assignee_id: contato.assignee_id,
                source_channel_id: contato.source_channel_id,
                observacoes: contato.observacoes
            };
            const { data } = await api.post('/comercial/contatos', payload);
            fetchContatos();
            return data;
        } catch (err) {
            console.error("Erro ao adicionar contato:", err);
            throw err;
        }
    }, [fetchContatos]);

    const updateContato = useCallback(async (id, patch) => {
        try {
            const payload = {
                nome: patch.nome,
                cargo: patch.cargo_id || patch.cargo,
                company_id: patch.company_id,
                telefone: patch.telefone,
                email: patch.email,
                assignee_id: patch.assignee_id,
                source_channel_id: patch.source_channel_id,
                observacoes: patch.observacoes
            };
            await api.put(`/comercial/contatos/${id}`, payload);
            fetchContatos();
        } catch (err) {
            console.error("Erro ao atualizar contato:", err);
            throw err;
        }
    }, [fetchContatos]);

    const deleteContato = useCallback(async (id) => {
        try {
            await api.delete(`/comercial/contatos/${id}`);
            fetchContatos();
        } catch (err) {
            console.error("Erro ao deletar contato:", err);
            throw err;
        }
    }, [fetchContatos]);

    // --- Metas CRUD ---
    const [metasPessoais, setMetasPessoais] = useState(() => {
        const saved = localStorage.getItem(STORAGE_METAS_PESSOAIS);
        return saved ?JSON.parse(saved) : metasPessoaisMockInitial;
    });

    const [metasGerais, setMetasGerais] = useState(() => {
        const saved = localStorage.getItem(STORAGE_METAS_GERAIS);
        return saved ?JSON.parse(saved) : metasGeraisMockInitial;
    });

    const saveMetasPessoais = useCallback((data) => {
        setMetasPessoais(data);
        localStorage.setItem(STORAGE_METAS_PESSOAIS, JSON.stringify(data));
    }, []);

    const saveMetasGerais = useCallback((data) => {
        setMetasGerais(data);
        localStorage.setItem(STORAGE_METAS_GERAIS, JSON.stringify(data));
    }, []);

    const addMeta = useCallback((meta, tipo = 'pessoal') => {
        const nova = { ...meta, id: `meta-${Date.now()}`, criadoEm: new Date().toISOString() };
        if (tipo === 'pessoal') {
            saveMetasPessoais([nova, ...metasPessoais]);
        } else {
            saveMetasGerais([nova, ...metasGerais]);
        }
        return nova;
    }, [metasPessoais, metasGerais, saveMetasPessoais, saveMetasGerais]);

    const updateMeta = useCallback((id, patch, tipo = 'pessoal') => {
        if (tipo === 'pessoal') {
            saveMetasPessoais(metasPessoais.map(m => m.id === id ?{ ...m, ...patch } : m));
        } else {
            saveMetasGerais(metasGerais.map(m => m.id === id ?{ ...m, ...patch } : m));
        }
    }, [metasPessoais, metasGerais, saveMetasPessoais, saveMetasGerais]);

    const deleteMeta = useCallback((id, tipo = 'pessoal') => {
        if (tipo === 'pessoal') {
            saveMetasPessoais(metasPessoais.filter(m => m.id !== id));
        } else {
            saveMetasGerais(metasGerais.filter(m => m.id !== id));
        }
    }, [metasPessoais, metasGerais, saveMetasPessoais, saveMetasGerais]);

    // --- Indicadores ---
    const indicadores = useMemo(() => {
        const abertos = negocios.filter(n => !n.completed && n.etapa !== 'ganho' && n.etapa !== 'perdido');
        const ganhos   = negocios.filter(n => n.etapa === 'ganho');
        const perdidos = negocios.filter(n => n.etapa === 'perdido');
        const totalPipeline = abertos.reduce((acc, n) => acc + (Number(n.valor) || 0), 0);
        const totalGanhos   = ganhos.reduce((acc, n) => acc + (Number(n.valor) || 0), 0);
        const taxaConversao = negocios.length > 0
            ?Math.round((ganhos.length / negocios.length) * 100)
            : 0;
        const ticketMedio = ganhos.length > 0
            ?Math.round(totalGanhos / ganhos.length)
            : 0;
        return {
            total: negocios.length,
            abertos: abertos.length,
            ganhos: ganhos.length,
            perdidos: perdidos.length,
            totalPipeline,
            totalGanhos,
            taxaConversao,
            ticketMedio,
        };
    }, [negocios]);

    return (
        <ComercialContext.Provider value={{
            // Negocios (dashboard/contatos/atividades)
            negocios,
            contatos,
            atividades,
            indicadores,
            addNegocio, updateNegocio, deleteNegocio, moverEtapa,
            addContato, updateContato, deleteContato,
            addAtividade, updateAtividade, deleteAtividade,
            // Pipeline boards
            pipelines,
            pipelineCards: pipelineCardsWithCompromissos,
            addPipeline, updatePipeline, deletePipeline,
            addColuna, updateColuna, deleteColuna,
            addPipelineCard, updatePipelineCard, deletePipelineCard, moverCard,
            reabrirItem,
            resultadosNegocio, fetchResultadosNegocio,
            canaisDropdown, fetchCanais,
            tiposAtividade, fetchTiposAtividade,
            statusAtividade, fetchStatusAtividade,
            compromissos,
            addCompromisso, updateCompromisso, deleteCompromisso,
            // Metas
            metasPessoais, metasGerais,
            addMeta, updateMeta, deleteMeta,
        }}>
            {children}
        </ComercialContext.Provider>
    );
};

export const useComercial = () => {
    const ctx = useContext(ComercialContext);
    if (!ctx) throw new Error('useComercial deve estar dentro de ComercialProvider');
    return ctx;
};
